<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.overviews') }} > {{ $t('sidebar.skuslevel') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <div
        class="row"
        style="margin-bottom: 12px;">
        <div class="col-lg-4 ml-auto">
          <label class="d-flex d-flex align-items-center">
            <span class="mr-2">
              {{ $t('message.search') }}:
            </span>
            <BaseInput
              v-model="query.q"
              :placeholder="$t('placeholder.searchstock')"
              type="text"
              clear
              @onEnter="handleSearchEnter"
              @onClear="handleSearchClear"
            />
          </label>
        </div>
      </div>
      <BaseTableSkuLevel
        :headColumns="headColumns"
        :rows="data"
        :pagination="pagination"
        :empty="empty"
        :query="query"
        @onSortChange="handleSortChange"
        @onPageChange="handlePageChange"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import useBarcodeScanner from '../../../../use/barcodeScanner'

export default {
  setup () {
    const {
      barcode,
    } = useBarcodeScanner({ delay: 100 })

    return {
      barcode,
    }
  },

  data () {
    return {
      loading: true,
      query: {
        page: this.$route.query.page,
        q: this.$route.query.q,
        sort_key: this.$route.query.sort_key,
        sort_value: this.$route.query.sort_value,
      },
      headColumns: [
        {
          text: this.$t('message.item'),
          style: '',
        },
        {
          text: this.$t('apps.inventory.message.lot'),
          style: 'width: 100px',
        },
        {
          text: this.$t('apps.inventory.message.serial'),
          style: 'width: 100px',
        },
        {
          text: this.$t('apps.inventory.message.reserved'),
          style: 'width: 100px',
        },
        {
          text: this.$t('apps.inventory.message.outhand'),
          style: 'width: 100px',
        },
        {
          text: this.$t('apps.inventory.message.onhand'),
          style: 'width: 100px',
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      data: 'getLevelSkus',
    }),
    empty () {
      return !this.data.length
    },
    pagination () {
      return this.$store.state.app.pagination
    },
  },

  watch: {
    warehouses () {
      sidebarModule.init(_.cloneDeep(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 0,
        submenuAtIdx: 1,
      })
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = null
        this.query.q = null
        this.query.sort_key = null
        this.query.sort_value = null
        this.fetchData()
      }
    },
  },

  async created () {
    await this.$store.dispatch('getWarehouses')
    this.updateUrl()
    this.loading = true
    await Promise.all([
      this.getSkuLevel(),
      this.$store.dispatch('getWarehouses'),
    ])
    this.loading = false
    this.showFinish(this.$Progress)
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 1,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 0,
      submenuAtIdx: 1,
    })
  },

  mounted () {
    window.addEventListener('barcode', this.onBarcode)
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
    window.removeEventListener('barcode', this.onBarcode)
  },

  methods: {
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.getSkuLevel()
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getSkuLevel () {
      return this.$store.dispatch('getSkuLevel', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        q: this.query.q,
        'sort[key]': this.query.sort_key,
        'sort[value]': this.query.sort_value,
      })
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
    handleSearchEnter () {
      this.query.page = null
      this.fetchData()
    },
    handleSearchClear () {
      this.query.page = null
      // comment this line because of bugs on BaseTableSkuLevel component
      // this.query.q = null
      this.fetchData()
    },
    handleSortChange ({ key, value }) {
      this.query.sort_key = key
      this.query.sort_value = value
      this.fetchData()
    },
    handlePageChange (pageNum) {
      this.query.page = pageNum
      this.fetchData()
    },
    onBarcode (event) {
      this.query.q = event.detail.code
      this.query.page = undefined
      this.fetchData()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/overview/SkuLevel.vue